import type { MessageKey } from "./en";

// TODO:i18n — machine-translated placeholders, review with native speaker.
export const es: Partial<Record<MessageKey, string>> = {
  "nav.home": "Inicio",
  "nav.repos": "Repositorios",
  "nav.issues": "Buenas primeras tareas",
  "nav.developers": "Desarrolladores",
  "nav.submit": "Envía tu proyecto",

  "common.loading": "Cargando…",
  "common.error": "Algo salió mal",
  "common.retry": "Reintentar",
  "common.search": "Buscar",

  "hero.title": "Plataforma de código abierto KuberCoin",
  "hero.subtitle":
    "Descubre, contribuye y financia proyectos de código abierto en el ecosistema KuberCoin.",
  "hero.cta_browse": "Explorar proyectos",
  "hero.cta_submit": "Envía tu proyecto",

  "repos.stars": "estrellas",
  "repos.forks": "bifurcaciones",
  "repos.language": "Lenguaje",

  "footer.copyright": "© 2026 KuberCoin Código Abierto",
  "footer.license": "Publicado bajo la licencia MIT.",

  "nav.playground": "Zona de pruebas",
  "nav.changelog": "Registro de cambios",
  "nav.apiDocs": "Documentación API",
  "nav.contributors": "Colaboradores",
  "nav.devLogin": "Acceso dev",
  "nav.admin": "Admin",
  "nav.logout": "Cerrar sesión",

  "search.title": "Buscar",
  "search.placeholder": "Buscar repos, archivos, envíos…",
  "search.button": "Buscar",
  "search.filter.all": "Todo",
  "search.filter.repos": "Repos",
  "search.filter.files": "Archivos",
  "search.filter.submissions": "Envíos",
  "search.type.repository": "Repositorio",
  "search.type.file": "Archivo",
  "search.type.submission": "Envío",
  "search.empty": "No se encontraron resultados. Prueba con otro término.",

  "notifications.title": "Notificaciones",
  "notifications.markAllRead": "Marcar todo como leído",
  "notifications.markRead": "Marcar como leído",
  "notifications.empty": "No hay notificaciones aún.",

  "contributors.title": "Colaboradores",
  "contributors.subtitle":
    "Conoce a los desarrolladores del ecosistema de código abierto de KuberCoin.",
  "contributors.searchPlaceholder": "Buscar colaboradores…",
  "contributors.sort.activity": "Más activos",
  "contributors.sort.newest": "Más recientes",
  "contributors.sort.oldest": "Más antiguos",
  "contributors.sort.name": "Nombre A–Z",
  "contributors.emptySearch": "Ningún colaborador coincide con tu búsqueda.",
  "contributors.empty": "No hay colaboradores aún.",

  "pagination.previous": "Anterior",
  "pagination.next": "Siguiente",

  "rateLimit.slowDown": "Límite de solicitudes excedido — reduce la velocidad",

  "notFound.title": "Página no encontrada",
  "notFound.message": "La página que buscas no existe o ha sido movida.",
  "notFound.home": "Volver al inicio",

  "settings.title": "Configuración",
  "settings.theme": "Tema",
  "settings.themeDescription": "Elige tu tema de color preferido.",
  "settings.switchToLight": "Cambiar a claro",
  "settings.switchToDark": "Cambiar a oscuro",
  "settings.language": "Idioma",
  "settings.languageDescription": "Elige tu idioma preferido.",
  "settings.notifications": "Notificaciones",
  "settings.emailNotifications": "Notificaciones por correo",

  // --- Session ---
  "session.expired": "Tu sesión ha expirado. Inicia sesión de nuevo.",

  // --- Offline ---
  "offline.banner":
    "Estás sin conexión. Algunas funciones pueden no estar disponibles.",

  // --- Shortcuts ---
  "shortcuts.title": "Atajos de teclado",
  "shortcuts.hint": "Presiona ? para abrir/cerrar este diálogo",

  "activity.title": "Actividad reciente",
  "activity.subtitle":
    "Actividad reciente en el ecosistema de código abierto KuberCoin.",
  "activity.empty": "Sin actividad reciente.",

  "issues.title": "Buenas primeras tareas",
  "issues.subtitle":
    "Encuentra tareas para principiantes y comienza a contribuir.",
  "issues.empty": "No hay tareas abiertas en este momento.",
  "issues.difficulty.all": "Todas",
  "issues.difficulty.beginner": "Principiante",
  "issues.difficulty.intermediate": "Intermedio",
  "issues.viewRepo": "Ver repositorio",

  "apiDocs.title": "Documentación de API",
  "apiDocs.subtitle":
    "Explora la especificación de la API abierta de KuberCoin.",
  "apiDocs.loading": "Cargando especificación de API…",
  "apiDocs.error": "Error al cargar la especificación de API.",

  "time.justNow": "ahora mismo",
  "time.minutesAgo": "hace {n}m",
  "time.hoursAgo": "hace {n}h",
  "time.daysAgo": "hace {n}d",

  "empty.generic": "Nada aquí todavía.",
  "empty.noResults": "No se encontraron resultados.",
};
